/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as SettingsRouteImport } from './routes/settings'
import { Route as LoginRouteImport } from './routes/login'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as ToolsIndexRouteImport } from './routes/tools.index'
import { Route as SettingsIndexRouteImport } from './routes/settings/index'
import { Route as ReportsIndexRouteImport } from './routes/reports.index'
import { Route as ReportsPanelIndexRouteImport } from './routes/reports-panel.index'
import { Route as FeaturedCallsIndexRouteImport } from './routes/featured-calls.index'
import { Route as EmployeesIndexRouteImport } from './routes/employees/index'
import { Route as ConversationsIndexRouteImport } from './routes/conversations.index'
import { Route as ContactsIndexRouteImport } from './routes/contacts.index'
import { Route as CommunicationsIndexRouteImport } from './routes/communications/index'
import { Route as CallsIndexRouteImport } from './routes/calls.index'
import { Route as CalendarIndexRouteImport } from './routes/calendar/index'
import { Route as AutomationsIndexRouteImport } from './routes/automations.index'
import { Route as SettingsWebsitesRouteImport } from './routes/settings/websites'
import { Route as SettingsWebsiteTemplateRegistryRouteImport } from './routes/settings/website-template-registry'
import { Route as SettingsTenantRouteImport } from './routes/settings/tenant'
import { Route as SettingsPropertyLinksRouteImport } from './routes/settings/property-links'
import { Route as SettingsPropertiesRouteImport } from './routes/settings/properties'
import { Route as SettingsPreferencesRouteImport } from './routes/settings/preferences'
import { Route as SettingsNotificationsRouteImport } from './routes/settings/notifications'
import { Route as SettingsFunnelsRouteImport } from './routes/settings/funnels'
import { Route as SettingsEmployeesRouteImport } from './routes/settings/employees'
import { Route as SettingsCustomFieldsRouteImport } from './routes/settings/custom-fields'
import { Route as SettingsCredentialsRouteImport } from './routes/settings/credentials'
import { Route as EmployeesNewRouteImport } from './routes/employees/new'
import { Route as EmployeesAssistancesRouteImport } from './routes/employees/assistances'
import { Route as CommunicationsImportRouteImport } from './routes/communications/import'
import { Route as CatalogProductsRouteImport } from './routes/catalog/products'
import { Route as CallsReportsRouteImport } from './routes/calls.reports'
import { Route as SettingsIntegrationsIndexRouteImport } from './routes/settings/integrations.index'
import { Route as IntegrationsPipedriveIndexRouteImport } from './routes/integrations/pipedrive.index'
import { Route as EmployeesEmployeeIdIndexRouteImport } from './routes/employees/$employeeId.index'
import { Route as CatalogPropertiesIndexRouteImport } from './routes/catalog/properties.index'
import { Route as ToolsWorkflowsCreateRouteImport } from './routes/tools/workflows/create'
import { Route as SettingsIntegrationsIntegrationIdRouteImport } from './routes/settings/integrations.$integrationId'
import { Route as CatalogPropertiesPublicationsRouteImport } from './routes/catalog/properties.publications'
import { Route as CatalogPropertiesCreateRouteImport } from './routes/catalog/properties.create'
import { Route as ToolsWorkflowsWorkflowIdIndexRouteImport } from './routes/tools/workflows/$workflowId.index'
import { Route as EmployeesEmployeeIdExecutionsIndexRouteImport } from './routes/employees/$employeeId/executions/index'
import { Route as ToolsWorkflowsWorkflowIdEditRouteImport } from './routes/tools/workflows/$workflowId.edit'
import { Route as EmployeesEmployeeIdExecutionsExecutionIdRouteImport } from './routes/employees/$employeeId/executions/$executionId'
import { Route as CatalogPropertiesPropertyIdEditRouteImport } from './routes/catalog/properties.$propertyId.edit'

const SettingsRoute = SettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const UsersIndexRoute = UsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsIndexRoute = ToolsIndexRouteImport.update({
  id: '/tools/',
  path: '/tools/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIndexRoute = SettingsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => SettingsRoute,
} as any)
const ReportsIndexRoute = ReportsIndexRouteImport.update({
  id: '/reports/',
  path: '/reports/',
  getParentRoute: () => rootRouteImport,
} as any)
const ReportsPanelIndexRoute = ReportsPanelIndexRouteImport.update({
  id: '/reports-panel/',
  path: '/reports-panel/',
  getParentRoute: () => rootRouteImport,
} as any)
const FeaturedCallsIndexRoute = FeaturedCallsIndexRouteImport.update({
  id: '/featured-calls/',
  path: '/featured-calls/',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeesIndexRoute = EmployeesIndexRouteImport.update({
  id: '/employees/',
  path: '/employees/',
  getParentRoute: () => rootRouteImport,
} as any)
const ConversationsIndexRoute = ConversationsIndexRouteImport.update({
  id: '/conversations/',
  path: '/conversations/',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactsIndexRoute = ContactsIndexRouteImport.update({
  id: '/contacts/',
  path: '/contacts/',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunicationsIndexRoute = CommunicationsIndexRouteImport.update({
  id: '/communications/',
  path: '/communications/',
  getParentRoute: () => rootRouteImport,
} as any)
const CallsIndexRoute = CallsIndexRouteImport.update({
  id: '/calls/',
  path: '/calls/',
  getParentRoute: () => rootRouteImport,
} as any)
const CalendarIndexRoute = CalendarIndexRouteImport.update({
  id: '/calendar/',
  path: '/calendar/',
  getParentRoute: () => rootRouteImport,
} as any)
const AutomationsIndexRoute = AutomationsIndexRouteImport.update({
  id: '/automations/',
  path: '/automations/',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsWebsitesRoute = SettingsWebsitesRouteImport.update({
  id: '/websites',
  path: '/websites',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsWebsiteTemplateRegistryRoute =
  SettingsWebsiteTemplateRegistryRouteImport.update({
    id: '/website-template-registry',
    path: '/website-template-registry',
    getParentRoute: () => SettingsRoute,
  } as any)
const SettingsTenantRoute = SettingsTenantRouteImport.update({
  id: '/tenant',
  path: '/tenant',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsPropertyLinksRoute = SettingsPropertyLinksRouteImport.update({
  id: '/property-links',
  path: '/property-links',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsPropertiesRoute = SettingsPropertiesRouteImport.update({
  id: '/properties',
  path: '/properties',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsPreferencesRoute = SettingsPreferencesRouteImport.update({
  id: '/preferences',
  path: '/preferences',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsNotificationsRoute = SettingsNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsFunnelsRoute = SettingsFunnelsRouteImport.update({
  id: '/funnels',
  path: '/funnels',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsEmployeesRoute = SettingsEmployeesRouteImport.update({
  id: '/employees',
  path: '/employees',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCustomFieldsRoute = SettingsCustomFieldsRouteImport.update({
  id: '/custom-fields',
  path: '/custom-fields',
  getParentRoute: () => SettingsRoute,
} as any)
const SettingsCredentialsRoute = SettingsCredentialsRouteImport.update({
  id: '/credentials',
  path: '/credentials',
  getParentRoute: () => SettingsRoute,
} as any)
const EmployeesNewRoute = EmployeesNewRouteImport.update({
  id: '/employees/new',
  path: '/employees/new',
  getParentRoute: () => rootRouteImport,
} as any)
const EmployeesAssistancesRoute = EmployeesAssistancesRouteImport.update({
  id: '/employees/assistances',
  path: '/employees/assistances',
  getParentRoute: () => rootRouteImport,
} as any)
const CommunicationsImportRoute = CommunicationsImportRouteImport.update({
  id: '/communications/import',
  path: '/communications/import',
  getParentRoute: () => rootRouteImport,
} as any)
const CatalogProductsRoute = CatalogProductsRouteImport.update({
  id: '/catalog/products',
  path: '/catalog/products',
  getParentRoute: () => rootRouteImport,
} as any)
const CallsReportsRoute = CallsReportsRouteImport.update({
  id: '/calls/reports',
  path: '/calls/reports',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIntegrationsIndexRoute =
  SettingsIntegrationsIndexRouteImport.update({
    id: '/integrations/',
    path: '/integrations/',
    getParentRoute: () => SettingsRoute,
  } as any)
const IntegrationsPipedriveIndexRoute =
  IntegrationsPipedriveIndexRouteImport.update({
    id: '/integrations/pipedrive/',
    path: '/integrations/pipedrive/',
    getParentRoute: () => rootRouteImport,
  } as any)
const EmployeesEmployeeIdIndexRoute =
  EmployeesEmployeeIdIndexRouteImport.update({
    id: '/employees/$employeeId/',
    path: '/employees/$employeeId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogPropertiesIndexRoute = CatalogPropertiesIndexRouteImport.update({
  id: '/catalog/properties/',
  path: '/catalog/properties/',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsWorkflowsCreateRoute = ToolsWorkflowsCreateRouteImport.update({
  id: '/tools/workflows/create',
  path: '/tools/workflows/create',
  getParentRoute: () => rootRouteImport,
} as any)
const SettingsIntegrationsIntegrationIdRoute =
  SettingsIntegrationsIntegrationIdRouteImport.update({
    id: '/integrations/$integrationId',
    path: '/integrations/$integrationId',
    getParentRoute: () => SettingsRoute,
  } as any)
const CatalogPropertiesPublicationsRoute =
  CatalogPropertiesPublicationsRouteImport.update({
    id: '/catalog/properties/publications',
    path: '/catalog/properties/publications',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogPropertiesCreateRoute = CatalogPropertiesCreateRouteImport.update({
  id: '/catalog/properties/create',
  path: '/catalog/properties/create',
  getParentRoute: () => rootRouteImport,
} as any)
const ToolsWorkflowsWorkflowIdIndexRoute =
  ToolsWorkflowsWorkflowIdIndexRouteImport.update({
    id: '/tools/workflows/$workflowId/',
    path: '/tools/workflows/$workflowId/',
    getParentRoute: () => rootRouteImport,
  } as any)
const EmployeesEmployeeIdExecutionsIndexRoute =
  EmployeesEmployeeIdExecutionsIndexRouteImport.update({
    id: '/employees/$employeeId/executions/',
    path: '/employees/$employeeId/executions/',
    getParentRoute: () => rootRouteImport,
  } as any)
const ToolsWorkflowsWorkflowIdEditRoute =
  ToolsWorkflowsWorkflowIdEditRouteImport.update({
    id: '/tools/workflows/$workflowId/edit',
    path: '/tools/workflows/$workflowId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)
const EmployeesEmployeeIdExecutionsExecutionIdRoute =
  EmployeesEmployeeIdExecutionsExecutionIdRouteImport.update({
    id: '/employees/$employeeId/executions/$executionId',
    path: '/employees/$employeeId/executions/$executionId',
    getParentRoute: () => rootRouteImport,
  } as any)
const CatalogPropertiesPropertyIdEditRoute =
  CatalogPropertiesPropertyIdEditRouteImport.update({
    id: '/catalog/properties/$propertyId/edit',
    path: '/catalog/properties/$propertyId/edit',
    getParentRoute: () => rootRouteImport,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/settings': typeof SettingsRouteWithChildren
  '/calls/reports': typeof CallsReportsRoute
  '/catalog/products': typeof CatalogProductsRoute
  '/communications/import': typeof CommunicationsImportRoute
  '/employees/assistances': typeof EmployeesAssistancesRoute
  '/employees/new': typeof EmployeesNewRoute
  '/settings/credentials': typeof SettingsCredentialsRoute
  '/settings/custom-fields': typeof SettingsCustomFieldsRoute
  '/settings/employees': typeof SettingsEmployeesRoute
  '/settings/funnels': typeof SettingsFunnelsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/preferences': typeof SettingsPreferencesRoute
  '/settings/properties': typeof SettingsPropertiesRoute
  '/settings/property-links': typeof SettingsPropertyLinksRoute
  '/settings/tenant': typeof SettingsTenantRoute
  '/settings/website-template-registry': typeof SettingsWebsiteTemplateRegistryRoute
  '/settings/websites': typeof SettingsWebsitesRoute
  '/automations': typeof AutomationsIndexRoute
  '/calendar': typeof CalendarIndexRoute
  '/calls': typeof CallsIndexRoute
  '/communications': typeof CommunicationsIndexRoute
  '/contacts': typeof ContactsIndexRoute
  '/conversations': typeof ConversationsIndexRoute
  '/employees': typeof EmployeesIndexRoute
  '/featured-calls': typeof FeaturedCallsIndexRoute
  '/reports-panel': typeof ReportsPanelIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/tools': typeof ToolsIndexRoute
  '/users': typeof UsersIndexRoute
  '/catalog/properties/create': typeof CatalogPropertiesCreateRoute
  '/catalog/properties/publications': typeof CatalogPropertiesPublicationsRoute
  '/settings/integrations/$integrationId': typeof SettingsIntegrationsIntegrationIdRoute
  '/tools/workflows/create': typeof ToolsWorkflowsCreateRoute
  '/catalog/properties': typeof CatalogPropertiesIndexRoute
  '/employees/$employeeId': typeof EmployeesEmployeeIdIndexRoute
  '/integrations/pipedrive': typeof IntegrationsPipedriveIndexRoute
  '/settings/integrations': typeof SettingsIntegrationsIndexRoute
  '/catalog/properties/$propertyId/edit': typeof CatalogPropertiesPropertyIdEditRoute
  '/employees/$employeeId/executions/$executionId': typeof EmployeesEmployeeIdExecutionsExecutionIdRoute
  '/tools/workflows/$workflowId/edit': typeof ToolsWorkflowsWorkflowIdEditRoute
  '/employees/$employeeId/executions': typeof EmployeesEmployeeIdExecutionsIndexRoute
  '/tools/workflows/$workflowId': typeof ToolsWorkflowsWorkflowIdIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/calls/reports': typeof CallsReportsRoute
  '/catalog/products': typeof CatalogProductsRoute
  '/communications/import': typeof CommunicationsImportRoute
  '/employees/assistances': typeof EmployeesAssistancesRoute
  '/employees/new': typeof EmployeesNewRoute
  '/settings/credentials': typeof SettingsCredentialsRoute
  '/settings/custom-fields': typeof SettingsCustomFieldsRoute
  '/settings/employees': typeof SettingsEmployeesRoute
  '/settings/funnels': typeof SettingsFunnelsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/preferences': typeof SettingsPreferencesRoute
  '/settings/properties': typeof SettingsPropertiesRoute
  '/settings/property-links': typeof SettingsPropertyLinksRoute
  '/settings/tenant': typeof SettingsTenantRoute
  '/settings/website-template-registry': typeof SettingsWebsiteTemplateRegistryRoute
  '/settings/websites': typeof SettingsWebsitesRoute
  '/automations': typeof AutomationsIndexRoute
  '/calendar': typeof CalendarIndexRoute
  '/calls': typeof CallsIndexRoute
  '/communications': typeof CommunicationsIndexRoute
  '/contacts': typeof ContactsIndexRoute
  '/conversations': typeof ConversationsIndexRoute
  '/employees': typeof EmployeesIndexRoute
  '/featured-calls': typeof FeaturedCallsIndexRoute
  '/reports-panel': typeof ReportsPanelIndexRoute
  '/reports': typeof ReportsIndexRoute
  '/settings': typeof SettingsIndexRoute
  '/tools': typeof ToolsIndexRoute
  '/users': typeof UsersIndexRoute
  '/catalog/properties/create': typeof CatalogPropertiesCreateRoute
  '/catalog/properties/publications': typeof CatalogPropertiesPublicationsRoute
  '/settings/integrations/$integrationId': typeof SettingsIntegrationsIntegrationIdRoute
  '/tools/workflows/create': typeof ToolsWorkflowsCreateRoute
  '/catalog/properties': typeof CatalogPropertiesIndexRoute
  '/employees/$employeeId': typeof EmployeesEmployeeIdIndexRoute
  '/integrations/pipedrive': typeof IntegrationsPipedriveIndexRoute
  '/settings/integrations': typeof SettingsIntegrationsIndexRoute
  '/catalog/properties/$propertyId/edit': typeof CatalogPropertiesPropertyIdEditRoute
  '/employees/$employeeId/executions/$executionId': typeof EmployeesEmployeeIdExecutionsExecutionIdRoute
  '/tools/workflows/$workflowId/edit': typeof ToolsWorkflowsWorkflowIdEditRoute
  '/employees/$employeeId/executions': typeof EmployeesEmployeeIdExecutionsIndexRoute
  '/tools/workflows/$workflowId': typeof ToolsWorkflowsWorkflowIdIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/settings': typeof SettingsRouteWithChildren
  '/calls/reports': typeof CallsReportsRoute
  '/catalog/products': typeof CatalogProductsRoute
  '/communications/import': typeof CommunicationsImportRoute
  '/employees/assistances': typeof EmployeesAssistancesRoute
  '/employees/new': typeof EmployeesNewRoute
  '/settings/credentials': typeof SettingsCredentialsRoute
  '/settings/custom-fields': typeof SettingsCustomFieldsRoute
  '/settings/employees': typeof SettingsEmployeesRoute
  '/settings/funnels': typeof SettingsFunnelsRoute
  '/settings/notifications': typeof SettingsNotificationsRoute
  '/settings/preferences': typeof SettingsPreferencesRoute
  '/settings/properties': typeof SettingsPropertiesRoute
  '/settings/property-links': typeof SettingsPropertyLinksRoute
  '/settings/tenant': typeof SettingsTenantRoute
  '/settings/website-template-registry': typeof SettingsWebsiteTemplateRegistryRoute
  '/settings/websites': typeof SettingsWebsitesRoute
  '/automations/': typeof AutomationsIndexRoute
  '/calendar/': typeof CalendarIndexRoute
  '/calls/': typeof CallsIndexRoute
  '/communications/': typeof CommunicationsIndexRoute
  '/contacts/': typeof ContactsIndexRoute
  '/conversations/': typeof ConversationsIndexRoute
  '/employees/': typeof EmployeesIndexRoute
  '/featured-calls/': typeof FeaturedCallsIndexRoute
  '/reports-panel/': typeof ReportsPanelIndexRoute
  '/reports/': typeof ReportsIndexRoute
  '/settings/': typeof SettingsIndexRoute
  '/tools/': typeof ToolsIndexRoute
  '/users/': typeof UsersIndexRoute
  '/catalog/properties/create': typeof CatalogPropertiesCreateRoute
  '/catalog/properties/publications': typeof CatalogPropertiesPublicationsRoute
  '/settings/integrations/$integrationId': typeof SettingsIntegrationsIntegrationIdRoute
  '/tools/workflows/create': typeof ToolsWorkflowsCreateRoute
  '/catalog/properties/': typeof CatalogPropertiesIndexRoute
  '/employees/$employeeId/': typeof EmployeesEmployeeIdIndexRoute
  '/integrations/pipedrive/': typeof IntegrationsPipedriveIndexRoute
  '/settings/integrations/': typeof SettingsIntegrationsIndexRoute
  '/catalog/properties/$propertyId/edit': typeof CatalogPropertiesPropertyIdEditRoute
  '/employees/$employeeId/executions/$executionId': typeof EmployeesEmployeeIdExecutionsExecutionIdRoute
  '/tools/workflows/$workflowId/edit': typeof ToolsWorkflowsWorkflowIdEditRoute
  '/employees/$employeeId/executions/': typeof EmployeesEmployeeIdExecutionsIndexRoute
  '/tools/workflows/$workflowId/': typeof ToolsWorkflowsWorkflowIdIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/login'
    | '/settings'
    | '/calls/reports'
    | '/catalog/products'
    | '/communications/import'
    | '/employees/assistances'
    | '/employees/new'
    | '/settings/credentials'
    | '/settings/custom-fields'
    | '/settings/employees'
    | '/settings/funnels'
    | '/settings/notifications'
    | '/settings/preferences'
    | '/settings/properties'
    | '/settings/property-links'
    | '/settings/tenant'
    | '/settings/website-template-registry'
    | '/settings/websites'
    | '/automations'
    | '/calendar'
    | '/calls'
    | '/communications'
    | '/contacts'
    | '/conversations'
    | '/employees'
    | '/featured-calls'
    | '/reports-panel'
    | '/reports'
    | '/settings/'
    | '/tools'
    | '/users'
    | '/catalog/properties/create'
    | '/catalog/properties/publications'
    | '/settings/integrations/$integrationId'
    | '/tools/workflows/create'
    | '/catalog/properties'
    | '/employees/$employeeId'
    | '/integrations/pipedrive'
    | '/settings/integrations'
    | '/catalog/properties/$propertyId/edit'
    | '/employees/$employeeId/executions/$executionId'
    | '/tools/workflows/$workflowId/edit'
    | '/employees/$employeeId/executions'
    | '/tools/workflows/$workflowId'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/calls/reports'
    | '/catalog/products'
    | '/communications/import'
    | '/employees/assistances'
    | '/employees/new'
    | '/settings/credentials'
    | '/settings/custom-fields'
    | '/settings/employees'
    | '/settings/funnels'
    | '/settings/notifications'
    | '/settings/preferences'
    | '/settings/properties'
    | '/settings/property-links'
    | '/settings/tenant'
    | '/settings/website-template-registry'
    | '/settings/websites'
    | '/automations'
    | '/calendar'
    | '/calls'
    | '/communications'
    | '/contacts'
    | '/conversations'
    | '/employees'
    | '/featured-calls'
    | '/reports-panel'
    | '/reports'
    | '/settings'
    | '/tools'
    | '/users'
    | '/catalog/properties/create'
    | '/catalog/properties/publications'
    | '/settings/integrations/$integrationId'
    | '/tools/workflows/create'
    | '/catalog/properties'
    | '/employees/$employeeId'
    | '/integrations/pipedrive'
    | '/settings/integrations'
    | '/catalog/properties/$propertyId/edit'
    | '/employees/$employeeId/executions/$executionId'
    | '/tools/workflows/$workflowId/edit'
    | '/employees/$employeeId/executions'
    | '/tools/workflows/$workflowId'
  id:
    | '__root__'
    | '/'
    | '/login'
    | '/settings'
    | '/calls/reports'
    | '/catalog/products'
    | '/communications/import'
    | '/employees/assistances'
    | '/employees/new'
    | '/settings/credentials'
    | '/settings/custom-fields'
    | '/settings/employees'
    | '/settings/funnels'
    | '/settings/notifications'
    | '/settings/preferences'
    | '/settings/properties'
    | '/settings/property-links'
    | '/settings/tenant'
    | '/settings/website-template-registry'
    | '/settings/websites'
    | '/automations/'
    | '/calendar/'
    | '/calls/'
    | '/communications/'
    | '/contacts/'
    | '/conversations/'
    | '/employees/'
    | '/featured-calls/'
    | '/reports-panel/'
    | '/reports/'
    | '/settings/'
    | '/tools/'
    | '/users/'
    | '/catalog/properties/create'
    | '/catalog/properties/publications'
    | '/settings/integrations/$integrationId'
    | '/tools/workflows/create'
    | '/catalog/properties/'
    | '/employees/$employeeId/'
    | '/integrations/pipedrive/'
    | '/settings/integrations/'
    | '/catalog/properties/$propertyId/edit'
    | '/employees/$employeeId/executions/$executionId'
    | '/tools/workflows/$workflowId/edit'
    | '/employees/$employeeId/executions/'
    | '/tools/workflows/$workflowId/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  LoginRoute: typeof LoginRoute
  SettingsRoute: typeof SettingsRouteWithChildren
  CallsReportsRoute: typeof CallsReportsRoute
  CatalogProductsRoute: typeof CatalogProductsRoute
  CommunicationsImportRoute: typeof CommunicationsImportRoute
  EmployeesAssistancesRoute: typeof EmployeesAssistancesRoute
  EmployeesNewRoute: typeof EmployeesNewRoute
  AutomationsIndexRoute: typeof AutomationsIndexRoute
  CalendarIndexRoute: typeof CalendarIndexRoute
  CallsIndexRoute: typeof CallsIndexRoute
  CommunicationsIndexRoute: typeof CommunicationsIndexRoute
  ContactsIndexRoute: typeof ContactsIndexRoute
  ConversationsIndexRoute: typeof ConversationsIndexRoute
  EmployeesIndexRoute: typeof EmployeesIndexRoute
  FeaturedCallsIndexRoute: typeof FeaturedCallsIndexRoute
  ReportsPanelIndexRoute: typeof ReportsPanelIndexRoute
  ReportsIndexRoute: typeof ReportsIndexRoute
  ToolsIndexRoute: typeof ToolsIndexRoute
  UsersIndexRoute: typeof UsersIndexRoute
  CatalogPropertiesCreateRoute: typeof CatalogPropertiesCreateRoute
  CatalogPropertiesPublicationsRoute: typeof CatalogPropertiesPublicationsRoute
  ToolsWorkflowsCreateRoute: typeof ToolsWorkflowsCreateRoute
  CatalogPropertiesIndexRoute: typeof CatalogPropertiesIndexRoute
  EmployeesEmployeeIdIndexRoute: typeof EmployeesEmployeeIdIndexRoute
  IntegrationsPipedriveIndexRoute: typeof IntegrationsPipedriveIndexRoute
  CatalogPropertiesPropertyIdEditRoute: typeof CatalogPropertiesPropertyIdEditRoute
  EmployeesEmployeeIdExecutionsExecutionIdRoute: typeof EmployeesEmployeeIdExecutionsExecutionIdRoute
  ToolsWorkflowsWorkflowIdEditRoute: typeof ToolsWorkflowsWorkflowIdEditRoute
  EmployeesEmployeeIdExecutionsIndexRoute: typeof EmployeesEmployeeIdExecutionsIndexRoute
  ToolsWorkflowsWorkflowIdIndexRoute: typeof ToolsWorkflowsWorkflowIdIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/settings': {
      id: '/settings'
      path: '/settings'
      fullPath: '/settings'
      preLoaderRoute: typeof SettingsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/users/': {
      id: '/users/'
      path: '/users'
      fullPath: '/users'
      preLoaderRoute: typeof UsersIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/': {
      id: '/tools/'
      path: '/tools'
      fullPath: '/tools'
      preLoaderRoute: typeof ToolsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/': {
      id: '/settings/'
      path: '/'
      fullPath: '/settings/'
      preLoaderRoute: typeof SettingsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/reports/': {
      id: '/reports/'
      path: '/reports'
      fullPath: '/reports'
      preLoaderRoute: typeof ReportsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/reports-panel/': {
      id: '/reports-panel/'
      path: '/reports-panel'
      fullPath: '/reports-panel'
      preLoaderRoute: typeof ReportsPanelIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/featured-calls/': {
      id: '/featured-calls/'
      path: '/featured-calls'
      fullPath: '/featured-calls'
      preLoaderRoute: typeof FeaturedCallsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/': {
      id: '/employees/'
      path: '/employees'
      fullPath: '/employees'
      preLoaderRoute: typeof EmployeesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/conversations/': {
      id: '/conversations/'
      path: '/conversations'
      fullPath: '/conversations'
      preLoaderRoute: typeof ConversationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contacts/': {
      id: '/contacts/'
      path: '/contacts'
      fullPath: '/contacts'
      preLoaderRoute: typeof ContactsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/communications/': {
      id: '/communications/'
      path: '/communications'
      fullPath: '/communications'
      preLoaderRoute: typeof CommunicationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calls/': {
      id: '/calls/'
      path: '/calls'
      fullPath: '/calls'
      preLoaderRoute: typeof CallsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calendar/': {
      id: '/calendar/'
      path: '/calendar'
      fullPath: '/calendar'
      preLoaderRoute: typeof CalendarIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/automations/': {
      id: '/automations/'
      path: '/automations'
      fullPath: '/automations'
      preLoaderRoute: typeof AutomationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/websites': {
      id: '/settings/websites'
      path: '/websites'
      fullPath: '/settings/websites'
      preLoaderRoute: typeof SettingsWebsitesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/website-template-registry': {
      id: '/settings/website-template-registry'
      path: '/website-template-registry'
      fullPath: '/settings/website-template-registry'
      preLoaderRoute: typeof SettingsWebsiteTemplateRegistryRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/tenant': {
      id: '/settings/tenant'
      path: '/tenant'
      fullPath: '/settings/tenant'
      preLoaderRoute: typeof SettingsTenantRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/property-links': {
      id: '/settings/property-links'
      path: '/property-links'
      fullPath: '/settings/property-links'
      preLoaderRoute: typeof SettingsPropertyLinksRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/properties': {
      id: '/settings/properties'
      path: '/properties'
      fullPath: '/settings/properties'
      preLoaderRoute: typeof SettingsPropertiesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/preferences': {
      id: '/settings/preferences'
      path: '/preferences'
      fullPath: '/settings/preferences'
      preLoaderRoute: typeof SettingsPreferencesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/notifications': {
      id: '/settings/notifications'
      path: '/notifications'
      fullPath: '/settings/notifications'
      preLoaderRoute: typeof SettingsNotificationsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/funnels': {
      id: '/settings/funnels'
      path: '/funnels'
      fullPath: '/settings/funnels'
      preLoaderRoute: typeof SettingsFunnelsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/employees': {
      id: '/settings/employees'
      path: '/employees'
      fullPath: '/settings/employees'
      preLoaderRoute: typeof SettingsEmployeesRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/custom-fields': {
      id: '/settings/custom-fields'
      path: '/custom-fields'
      fullPath: '/settings/custom-fields'
      preLoaderRoute: typeof SettingsCustomFieldsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/settings/credentials': {
      id: '/settings/credentials'
      path: '/credentials'
      fullPath: '/settings/credentials'
      preLoaderRoute: typeof SettingsCredentialsRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/employees/new': {
      id: '/employees/new'
      path: '/employees/new'
      fullPath: '/employees/new'
      preLoaderRoute: typeof EmployeesNewRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/assistances': {
      id: '/employees/assistances'
      path: '/employees/assistances'
      fullPath: '/employees/assistances'
      preLoaderRoute: typeof EmployeesAssistancesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/communications/import': {
      id: '/communications/import'
      path: '/communications/import'
      fullPath: '/communications/import'
      preLoaderRoute: typeof CommunicationsImportRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/products': {
      id: '/catalog/products'
      path: '/catalog/products'
      fullPath: '/catalog/products'
      preLoaderRoute: typeof CatalogProductsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/calls/reports': {
      id: '/calls/reports'
      path: '/calls/reports'
      fullPath: '/calls/reports'
      preLoaderRoute: typeof CallsReportsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/integrations/': {
      id: '/settings/integrations/'
      path: '/integrations'
      fullPath: '/settings/integrations'
      preLoaderRoute: typeof SettingsIntegrationsIndexRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/integrations/pipedrive/': {
      id: '/integrations/pipedrive/'
      path: '/integrations/pipedrive'
      fullPath: '/integrations/pipedrive'
      preLoaderRoute: typeof IntegrationsPipedriveIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/$employeeId/': {
      id: '/employees/$employeeId/'
      path: '/employees/$employeeId'
      fullPath: '/employees/$employeeId'
      preLoaderRoute: typeof EmployeesEmployeeIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/properties/': {
      id: '/catalog/properties/'
      path: '/catalog/properties'
      fullPath: '/catalog/properties'
      preLoaderRoute: typeof CatalogPropertiesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/workflows/create': {
      id: '/tools/workflows/create'
      path: '/tools/workflows/create'
      fullPath: '/tools/workflows/create'
      preLoaderRoute: typeof ToolsWorkflowsCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/settings/integrations/$integrationId': {
      id: '/settings/integrations/$integrationId'
      path: '/integrations/$integrationId'
      fullPath: '/settings/integrations/$integrationId'
      preLoaderRoute: typeof SettingsIntegrationsIntegrationIdRouteImport
      parentRoute: typeof SettingsRoute
    }
    '/catalog/properties/publications': {
      id: '/catalog/properties/publications'
      path: '/catalog/properties/publications'
      fullPath: '/catalog/properties/publications'
      preLoaderRoute: typeof CatalogPropertiesPublicationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/properties/create': {
      id: '/catalog/properties/create'
      path: '/catalog/properties/create'
      fullPath: '/catalog/properties/create'
      preLoaderRoute: typeof CatalogPropertiesCreateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/workflows/$workflowId/': {
      id: '/tools/workflows/$workflowId/'
      path: '/tools/workflows/$workflowId'
      fullPath: '/tools/workflows/$workflowId'
      preLoaderRoute: typeof ToolsWorkflowsWorkflowIdIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/$employeeId/executions/': {
      id: '/employees/$employeeId/executions/'
      path: '/employees/$employeeId/executions'
      fullPath: '/employees/$employeeId/executions'
      preLoaderRoute: typeof EmployeesEmployeeIdExecutionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/tools/workflows/$workflowId/edit': {
      id: '/tools/workflows/$workflowId/edit'
      path: '/tools/workflows/$workflowId/edit'
      fullPath: '/tools/workflows/$workflowId/edit'
      preLoaderRoute: typeof ToolsWorkflowsWorkflowIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/employees/$employeeId/executions/$executionId': {
      id: '/employees/$employeeId/executions/$executionId'
      path: '/employees/$employeeId/executions/$executionId'
      fullPath: '/employees/$employeeId/executions/$executionId'
      preLoaderRoute: typeof EmployeesEmployeeIdExecutionsExecutionIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/catalog/properties/$propertyId/edit': {
      id: '/catalog/properties/$propertyId/edit'
      path: '/catalog/properties/$propertyId/edit'
      fullPath: '/catalog/properties/$propertyId/edit'
      preLoaderRoute: typeof CatalogPropertiesPropertyIdEditRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface SettingsRouteChildren {
  SettingsCredentialsRoute: typeof SettingsCredentialsRoute
  SettingsCustomFieldsRoute: typeof SettingsCustomFieldsRoute
  SettingsEmployeesRoute: typeof SettingsEmployeesRoute
  SettingsFunnelsRoute: typeof SettingsFunnelsRoute
  SettingsNotificationsRoute: typeof SettingsNotificationsRoute
  SettingsPreferencesRoute: typeof SettingsPreferencesRoute
  SettingsPropertiesRoute: typeof SettingsPropertiesRoute
  SettingsPropertyLinksRoute: typeof SettingsPropertyLinksRoute
  SettingsTenantRoute: typeof SettingsTenantRoute
  SettingsWebsiteTemplateRegistryRoute: typeof SettingsWebsiteTemplateRegistryRoute
  SettingsWebsitesRoute: typeof SettingsWebsitesRoute
  SettingsIndexRoute: typeof SettingsIndexRoute
  SettingsIntegrationsIntegrationIdRoute: typeof SettingsIntegrationsIntegrationIdRoute
  SettingsIntegrationsIndexRoute: typeof SettingsIntegrationsIndexRoute
}

const SettingsRouteChildren: SettingsRouteChildren = {
  SettingsCredentialsRoute: SettingsCredentialsRoute,
  SettingsCustomFieldsRoute: SettingsCustomFieldsRoute,
  SettingsEmployeesRoute: SettingsEmployeesRoute,
  SettingsFunnelsRoute: SettingsFunnelsRoute,
  SettingsNotificationsRoute: SettingsNotificationsRoute,
  SettingsPreferencesRoute: SettingsPreferencesRoute,
  SettingsPropertiesRoute: SettingsPropertiesRoute,
  SettingsPropertyLinksRoute: SettingsPropertyLinksRoute,
  SettingsTenantRoute: SettingsTenantRoute,
  SettingsWebsiteTemplateRegistryRoute: SettingsWebsiteTemplateRegistryRoute,
  SettingsWebsitesRoute: SettingsWebsitesRoute,
  SettingsIndexRoute: SettingsIndexRoute,
  SettingsIntegrationsIntegrationIdRoute:
    SettingsIntegrationsIntegrationIdRoute,
  SettingsIntegrationsIndexRoute: SettingsIntegrationsIndexRoute,
}

const SettingsRouteWithChildren = SettingsRoute._addFileChildren(
  SettingsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  LoginRoute: LoginRoute,
  SettingsRoute: SettingsRouteWithChildren,
  CallsReportsRoute: CallsReportsRoute,
  CatalogProductsRoute: CatalogProductsRoute,
  CommunicationsImportRoute: CommunicationsImportRoute,
  EmployeesAssistancesRoute: EmployeesAssistancesRoute,
  EmployeesNewRoute: EmployeesNewRoute,
  AutomationsIndexRoute: AutomationsIndexRoute,
  CalendarIndexRoute: CalendarIndexRoute,
  CallsIndexRoute: CallsIndexRoute,
  CommunicationsIndexRoute: CommunicationsIndexRoute,
  ContactsIndexRoute: ContactsIndexRoute,
  ConversationsIndexRoute: ConversationsIndexRoute,
  EmployeesIndexRoute: EmployeesIndexRoute,
  FeaturedCallsIndexRoute: FeaturedCallsIndexRoute,
  ReportsPanelIndexRoute: ReportsPanelIndexRoute,
  ReportsIndexRoute: ReportsIndexRoute,
  ToolsIndexRoute: ToolsIndexRoute,
  UsersIndexRoute: UsersIndexRoute,
  CatalogPropertiesCreateRoute: CatalogPropertiesCreateRoute,
  CatalogPropertiesPublicationsRoute: CatalogPropertiesPublicationsRoute,
  ToolsWorkflowsCreateRoute: ToolsWorkflowsCreateRoute,
  CatalogPropertiesIndexRoute: CatalogPropertiesIndexRoute,
  EmployeesEmployeeIdIndexRoute: EmployeesEmployeeIdIndexRoute,
  IntegrationsPipedriveIndexRoute: IntegrationsPipedriveIndexRoute,
  CatalogPropertiesPropertyIdEditRoute: CatalogPropertiesPropertyIdEditRoute,
  EmployeesEmployeeIdExecutionsExecutionIdRoute:
    EmployeesEmployeeIdExecutionsExecutionIdRoute,
  ToolsWorkflowsWorkflowIdEditRoute: ToolsWorkflowsWorkflowIdEditRoute,
  EmployeesEmployeeIdExecutionsIndexRoute:
    EmployeesEmployeeIdExecutionsIndexRoute,
  ToolsWorkflowsWorkflowIdIndexRoute: ToolsWorkflowsWorkflowIdIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
